import { useMutation, useQueryClient } from '@tanstack/react-query';
import { translationsService } from '../services/translations.service';
import type {
  SaveTranslationPayload,
  AutoTranslatePayload,
} from '../types/api.types';
import toast from 'react-hot-toast';
import { segmentKeys } from './useSegments';

// Save/update manual translation
export function useSaveTranslation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: SaveTranslationPayload) =>
      translationsService.saveTranslation(payload),
    onSuccess: () => {
      // Invalidate segments to refresh translations
      queryClient.invalidateQueries({
        queryKey: segmentKeys.all,
      });
      toast.success('Translation saved');
    },
    onError: (error: Error) => {
      toast.error(`Failed to save translation: ${error.message}`);
    },
  });
}

// Request auto-translation
export function useAutoTranslate() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: AutoTranslatePayload) =>
      translationsService.autoTranslate(payload),
    onSuccess: () => {
      // Invalidate segments to refresh translations
      queryClient.invalidateQueries({
        queryKey: segmentKeys.all,
      });
      toast.success('Auto-translation complete');
    },
    onError: (error: Error) => {
      toast.error(`Failed to auto-translate: ${error.message}`);
    },
  });
}
